import {inject, Injectable} from '@angular/core';
import {HttpBackend, HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EnvironmentService} from '../../../services/environment.service';

export interface WidgetPreviewFixtureState {
  fixtureKey: string;
  clientId: string;
  chatbotId: string;
  conversationId: string;
  seeded: boolean;
  messageCount: number;
}

@Injectable({providedIn: 'root'})
export class WidgetPreviewFixtureService {
  readonly reservedClientId = 'widget-preview-local';
  readonly reservedChatbotId = 'widget-preview-product-card';
  readonly localAiApiServerUrl = 'http://localhost:5002/';
  readonly localAiWebServerUrl = 'http://localhost:5003/';
  readonly localWidgetScriptUrl = 'http://localhost:5004/generic.js?v=1.0.0';

  private readonly http = new HttpClient(inject(HttpBackend));
  private readonly environmentService = inject(EnvironmentService);

  getProductCardState(clientId: string = this.reservedClientId, chatbotId: string = this.reservedChatbotId): Observable<WidgetPreviewFixtureState> {
    return this.http.get<WidgetPreviewFixtureState>(this.buildUrl(), {
      params: this.buildParams(clientId, chatbotId)
    });
  }

  seedProductCard(clientId: string = this.reservedClientId, chatbotId: string = this.reservedChatbotId): Observable<WidgetPreviewFixtureState> {
    return this.http.post<WidgetPreviewFixtureState>(this.buildUrl(), {}, {
      params: this.buildParams(clientId, chatbotId)
    });
  }

  resetProductCard(clientId: string = this.reservedClientId, chatbotId: string = this.reservedChatbotId): Observable<WidgetPreviewFixtureState> {
    return this.http.delete<WidgetPreviewFixtureState>(this.buildUrl(), {
      params: this.buildParams(clientId, chatbotId)
    });
  }

  private buildUrl(): string {
    return new URL('Conversation/WidgetPreviewFixture/ProductCard', this.resolveAiWebServerUrl()).toString();
  }

  private buildParams(clientId: string, chatbotId: string): HttpParams {
    return new HttpParams()
      .set('client', clientId)
      .set('chatbot', chatbotId);
  }

  private resolveAiWebServerUrl(): string {
    if (typeof window !== 'undefined' && window.location?.hostname === 'localhost') {
      return this.localAiWebServerUrl;
    }

    return this.environmentService.aiWebServerUrl;
  }
}
